import { z } from "zod";

export const ApprovalRuleSchema = z.object({
  field: z.string(), // dot notation path, e.g. "isdm.totalGrossAmount"
  operator: z.enum(["gt", "lt", "eq", "neq", "gte", "lte", "contains", "not_contains"]),
  value: z.any(),
});

export const ApprovalConfigSchema = z.object({
  rules: z.array(ApprovalRuleSchema),
  approvers: z.array(z.string()).optional(), // List of User IDs or Roles
  minApprovals: z.number().default(1),
  _nodeId: z.string().optional(), // Injected by Engine
});

export type ApprovalRule = z.infer<typeof ApprovalRuleSchema>;
export type ApprovalConfig = z.infer<typeof ApprovalConfigSchema>;
